import { render, staticRenderFns } from "./knowledgeForm.vue?vue&type=template&id=439e8d05&scoped=true&"
import script from "./knowledgeForm.vue?vue&type=script&lang=js&"
export * from "./knowledgeForm.vue?vue&type=script&lang=js&"
import style0 from "./knowledgeForm.vue?vue&type=style&index=0&id=439e8d05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439e8d05",
  null
  
)

export default component.exports